import { render } from "./appBusiness.vue?vue&type=template&id=65f2c34e&scoped=true"
import script from "./appBusiness.vue?vue&type=script&lang=js"
export * from "./appBusiness.vue?vue&type=script&lang=js"

import "./appBusiness.vue?vue&type=style&index=0&id=65f2c34e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-65f2c34e"

export default script